module.exports = __webpack_public_path__ + "static/media/rse.b9d48c7a.png";